import { AuthenticationTriggerWrapper } from '@/components/buttons/AuthenticationTriggerWrapper';
import { useMarketplaceChain } from '@/hooks/use-marketplace-chain';
import { isImmutableChain } from '@/utils/immutable';
import { ReservoirAction } from '@/utils/reservoir';
import { CancelBidModal, CancelBidStep } from '@sphere/reservoir-kit-ui';
import useTranslation from 'next-translate/useTranslation';
import { type FC, type ReactElement } from 'react';
import { toast } from 'sonner';
import ActionDisabledTooltip from './ActionDisabledTooltip';

type Props = {
  bidId: string;
  openState?: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  trigger: ReactElement;
  mutate?: () => void;
};

const CancelBid: FC<Props> = ({ bidId, openState, trigger, mutate }) => {
  const { t } = useTranslation('common');
  const marketplaceChain = useMarketplaceChain();

  const WrappedTrigger = (
    <ActionDisabledTooltip action={ReservoirAction.CancelBid}>{trigger}</ActionDisabledTooltip>
  );

  return (
    <AuthenticationTriggerWrapper trigger={WrappedTrigger}>
      <CancelBidModal
        bidId={bidId}
        trigger={WrappedTrigger}
        openState={openState}
        chainId={marketplaceChain.id}
        onClose={(data, currentStep) => {
          if (mutate && currentStep == CancelBidStep.Complete) mutate();
        }}
        onCancelComplete={() => {
          toast.success(t('toast.cancel-bid.success.title'), {
            description: t('toast.cancel-bid.success.description'),
          });
        }}
        onCancelError={() => {
          toast.error(t('toast.cancel-bid.transaction-incomplete.title'));
        }}
        withoutGasFees={isImmutableChain(marketplaceChain.id)}
      />
    </AuthenticationTriggerWrapper>
  );
};

export default CancelBid;
